import { Button, ButtonGroup } from "@chakra-ui/react";
import PointsChart from "../charts/PointsChart";

const MarksDailyChart = ({ isKeyMintAvailiable, chartData, isUserHasKey, rankData, onMintModalOpen, setFilter, filter, filteredChartData }) => {
	return (
		<>
			<ButtonGroup size="xs" isAttached variant="outline" mb={4}>
				<Button variant={filter === 'all' ? 'custom' : 'outline'}
					onClick={() => setFilter('all')}>
					All Time
				</Button>
				<Button variant={filter === 'lastWeek' ? 'custom' : 'outline'}
					onClick={() => setFilter('lastWeek')}>
					Last Week
				</Button>
			</ButtonGroup>
			<PointsChart data={filteredChartData} />
		</>
	)
}

export default MarksDailyChart;